<template>
    <div>
        <h2 v-if="albumId !== 'photo'" class="sh-line is-size-2 has-text-centered">
            <span>Slike</span>
        </h2>

        <silentbox-group class="columns is-multiline is-gapless">
            <div v-for="photo in images" :key="photo.image" class="column is-4 photos">
                <silentbox-item :src="photo.path" :description="photo.caption" :autoplay="true" >
                    <img :src="photo.src" :alt="photo.caption" width="300" height="225"/>
                    <div class="hide-overlay">
                        <p class="if-photo" v-if="albumId==='photo-gallery'"><router-link :to="{ name: 'galleryPhotos', params: {  photo: photo.photoLink} }" @click.native="clickPriority">{{ photo.caption }}</router-link></p>
                        <p class="else-photo" v-else>
                            <router-link :to="{name: 'AlbumPhoto', params: {album: photo.albumLink, location:photo.locationLink,  photo: photo.photoLink}}" @click.native="clickPriority">{{ photo.caption }}</router-link>
                        </p>
                        <p> {{ photo.date }}</p>
                        <p>
                            <router-link :to="{name: 'AlbumLocation', params: {album: photo.albumLink, location: photo.locationLink}}" @click.native="clickPriority">{{ photo.location }}</router-link>
                        </p>
                    </div>
                </silentbox-item>
            </div>
            <h3 v-if="albumId !== 'photo-gallery'" class="links"><a :href="slug">Vse slike</a></h3>
        </silentbox-group>
    </div>
</template>

<script>
import { PhotoUrl, AlbumsPhotoUrl, LocationsPhotoUrl } from '../../../.env';
import StringsMixin from '../../../mixins/StringsMixin';

export default {
    name:'app-sb',
    mixins: [StringsMixin],
    // Displaying photos for particular album, albumId is known
    // For gallery is 'photo'
    props: ['photos', 'albumId'],
    data() {
        return {
            //
        };
    },

    computed: {
        images() {
            let photos = [];
            for (let i = 0; i < this.photos.length; i++) {
                let photo = this.photos[i];
                photos[i] = {
                    src: this.photoImage(photo),
                    caption: this.albumName(photo) + ' ' + this.capitalize(photo.location_title),
                    path: PhotoUrl + photo.album_id + '/960/' + photo.image,
                    date: photo.dateTaken,
                    location: this.capitalize(photo.location_name),
                    locationLink: photo.location_slug,
                    albumLink: this.setAlbumLink(photo),
                    photoLink: photo.slug,
                };
            }
            return photos;
        },
        slug() {
            return '/galerija/album/' + this.albumId ;
        }
    },

    methods: {
        setAlbumLink(photo) {
            if(photo.album_slug) {

                return photo.album_slug;
            }
            return this.albumId;
        },

        albumName(photo) {
            if(photo.album_name) {

                return this.capitalize(photo.album_name);
            }
            return this.capitalize(this.albumId);
        },
        photoImage(photo) {
            return PhotoUrl + photo.album_id + '/300/' + photo.image;
        },
        // Clicking on overlay links - prevent displayin silentbox
        clickPriority(event) {
            event.stopPropagation();
        }
    },

    created() {
        console.log('silentbox gallery created');
    },

};

</script>
<style lang="scss">
@import '../../../style/app.scss';
#silentbox-overlay__close-button {
    top: 20px !important;
    right: 20px !important;
}
#silentbox-overlay__container {
    margin: 0 !important;
}

#silentbox-overlay__arrow-buttons .arrow:hover, #silentbox-overlay__arrow-buttons .arrow:focus {
    border-color: lime !important;
}

#silentbox-overlay__description {
    margin-top: 0 !important;
    background-color: transparent !important;
    color: #fff !important;
    font-family: 'Roboto';
    font-size: 1.5rem;
    font-weight: 300;
}

#silentbox-overlay__container img {
    /*width: 100%;*/
}
</style>



// WEBPACK FOOTER //
// src/components/elements/silentbox/SilentboxGallery.vue